<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px"
    [@routeAnimation]="true">
    <div class="filter">
        <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
        </mat-form-field>
    </div>

    <div class="mat-elevation-z8 table-container">
        <mat-table class="mat-elevation-z8" #table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="requestNo">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Request No
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.requestNo}} </mat-cell>
            </ng-container>

            <!-- <ng-container matColumnDef="formName">
                <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef mat-sort-header> Request Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 3;" *matCellDef="let row"> {{row.formName}} </mat-cell>
            </ng-container> -->

            <ng-container matColumnDef="projectName">
                <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef mat-sort-header> Project Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 3;" *matCellDef="let row"> {{row.formName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="eventName">
                <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef mat-sort-header> Event Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 3;" *matCellDef="let row"> {{row.formName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="orgInfoName">
                <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef mat-sort-header> Organization Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 3;" *matCellDef="let row"> {{row.orgInfoName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="orgInfoSubsection">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Tax-Exempt Status
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{getTaxExemptStatus(row.orgInfoSubsection)}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dateRequest">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header>Request Date
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.dateRequest | date: 'MM-dd-yyyy'}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row" [ngClass]="getStatusClass(row.status)">
                    {{row.status}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="statusAdmin">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row" [ngClass]="getStatusClass(row.statusAdmin)">
                    {{row.statusAdmin}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="confirmationNo">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Confirmation No
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.confirmationNoCC}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="processCreditCardPayment">
                <mat-header-cell style="flex-grow: 2; justify-content:center;" *matHeaderCellDef> Process Payment
                </mat-header-cell>
                <mat-cell style="flex-grow: 2; justify-content:center;" *matCellDef="let row">
                    <button mat-icon-button (click)="payAsCreditCard(row)">
                        <mat-icon>payment</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="view">
                <mat-header-cell style="flex-grow: 1; justify-content:center;" *matHeaderCellDef></mat-header-cell>
                <mat-cell style="flex-grow: 1; justify-content:center;" *matCellDef="let row" style="text-align:right;">
                    <button mat-icon-button matTooltip="View" matTooltipShowDelay="200" (click)="selectRow(row)">
                        <mat-icon color="primary">folder_open</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
    </div>
    <div>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100, 125, 150, 175, 200]"></mat-paginator>
    </div>
</div>